
// import React, { useState, useEffect, useRef } from 'react';

// const SmsEmail = ({LeadACVLRecordID, PhoneNumber}) => {
//   // Configuration
//   const API_BASE_URL = 'https://salesjet-841904208.development.catalystserverless.com/server/SMSRecords';
//   const EMAIL_SERVICE_URL = 'https://salesjet-841904208.development.catalystserverless.com/server/salesjet_function';
  
//   // Use the prop as the dynamic lead ID, fallback to default if not provided
//   const LEAD_ID = LeadACVLRecordID || 'LEAD_22222';
//   const TO_NUMBER =  '+14166134241';

//   // State
//   const [allMessages, setAllMessages] = useState([]);
//   const [currentFilter, setCurrentFilter] = useState('all');
//   const [inputMode, setInputMode] = useState('sms');
//   const [smsText, setSmsText] = useState('');
//   const [fromNumber, setFromNumber] = useState('+16478463028');
//   const [emailFormData, setEmailFormData] = useState({
//     from: 'support@yourdomain.com',
//     to: '',
//     cc: '',
//     bcc: '',
//     subject: '',
//     body: ''
//   });
//   const [attachments, setAttachments] = useState([]);
//   const [hoveredIndex, setHoveredIndex] = useState(-1);
//   const [previewAttachment, setPreviewAttachment] = useState(null);

//   // Refs
//   const messagesContainerRef = useRef(null);
//   const timelineBarRef = useRef(null);

//   // Load messages on mount and when LEAD_ID changes
//   useEffect(() => {
//     loadMessages();
//   }, [LEAD_ID]);

//   // Initialize dock effect
//   useEffect(() => {
//     const timelineBar = timelineBarRef.current;
//     if (!timelineBar) return;

//     const handleMouseMove = (e) => {
//       const items = Array.from(timelineBar.querySelectorAll('.timeline-item'));
//       let currentHoveredIndex = -1;

//       items.forEach((item, idx) => {
//         const rect = item.getBoundingClientRect();
//         const itemCenter = rect.left + rect.width / 2;
//         const distance = Math.abs(e.clientX - itemCenter);
//         if (distance < 40) {
//           currentHoveredIndex = idx;
//         }
//       });

//       setHoveredIndex(currentHoveredIndex);
//     };

//     const handleMouseLeave = () => {
//       setHoveredIndex(-1);
//     };

//     timelineBar.addEventListener('mousemove', handleMouseMove);
//     timelineBar.addEventListener('mouseleave', handleMouseLeave);

//     return () => {
//       timelineBar.removeEventListener('mousemove', handleMouseMove);
//       timelineBar.removeEventListener('mouseleave', handleMouseLeave);
//     };
//   }, [allMessages]);

//   // Auto-scroll messages
//   useEffect(() => {
//     if (messagesContainerRef.current) {
//       messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
//     }
//   }, [allMessages, currentFilter]);

//   const loadMessages = async () => {
//     try {
//       const url = `${API_BASE_URL}/get_unified_history?lead_id=${encodeURIComponent(LEAD_ID)}`;
//       const response = await fetch(url);
//       if (response.ok) {
//         const data = await response.json();
//         setAllMessages(data.messages || []);
//       }
//     } catch (error) {
//       console.error('Error loading messages:', error);
//     }
//   };

//   const filterMessages = (type) => {
//     setCurrentFilter(type);
//   };

//   const getFilteredMessages = () => {
//     if (currentFilter === 'all') return allMessages;
//     return allMessages.filter(m => m.type === currentFilter);
//   };

//   const getMessageCounts = () => {
//     return {
//       all: allMessages.length,
//       sms: allMessages.filter(m => m.type === 'sms').length,
//       email: allMessages.filter(m => m.type === 'email').length
//     };
//   };

//   const sendChatMessage = async () => {
//     if (!smsText.trim()) return;

//     const now = new Date();
//     const time = now.getHours().toString().padStart(2, '0') + ':' + 
//                  now.getMinutes().toString().padStart(2, '0');

//     // Optimistic update
//     const tempMessage = {
//       type: 'sms',
//       direction: 'outbound',
//       from: fromNumber,
//       to: TO_NUMBER,
//       text: smsText,
//       timestamp: new Date().toISOString(),
//       lead_id: LEAD_ID
//     };
//     setAllMessages([...allMessages, tempMessage]);
//     setSmsText('');

//     try {
//       const url = `${API_BASE_URL}/sendSMS?from=${encodeURIComponent(fromNumber)}&to=${encodeURIComponent(TO_NUMBER)}&text=${encodeURIComponent(smsText)}&lead_id=${encodeURIComponent(LEAD_ID)}`;
//       const response = await fetch(url, { method: 'GET' });
      
//       if (response.ok) {
//         setTimeout(() => loadMessages(), 1000);
//       }
//     } catch (error) {
//       console.error('Error sending SMS:', error);
//     }
//   };

//   const sendEmail = async (e) => {
//     e.preventDefault();

//     const formData = new FormData();
//     formData.append('from', emailFormData.from);
//     formData.append('to', emailFormData.to);
//     formData.append('subject', emailFormData.subject);
//     formData.append('text', emailFormData.body);
//     formData.append('leadId', LEAD_ID);

//     if (emailFormData.cc) formData.append('cc', emailFormData.cc);
//     if (emailFormData.bcc) formData.append('bcc', emailFormData.bcc);

//     attachments.forEach(file => {
//       formData.append('attachment', file);
//     });

//     // Optimistic update
//     const tempMessage = {
//       type: 'email',
//       direction: 'outbound',
//       from: emailFormData.from,
//       to: emailFormData.to,
//       subject: emailFormData.subject,
//       text: emailFormData.body,
//       timestamp: new Date().toISOString(),
//       lead_id: LEAD_ID
//     };
//     setAllMessages([...allMessages, tempMessage]);

//     try {
//       const response = await fetch(`${API_BASE_URL}/sendEmail`, {
//         method: 'POST',
//         body: formData
//       });

//       if (response.ok) {
//         setEmailFormData({
//           from: 'support@yourdomain.com',
//           to: '',
//           cc: '',
//           bcc: '',
//           subject: '',
//           body: ''
//         });
//         setAttachments([]);
//         setInputMode('sms');
//         setTimeout(() => loadMessages(), 1000);
//       }
//     } catch (error) {
//       console.error('Error sending email:', error);
//     }
//   };

//   const handleFileChange = (e) => {
//     setAttachments(Array.from(e.target.files));
//   };

//   const openAttachment = async (fileId, fileName, contentType) => {
//     try {
//       const response = await fetch(`${EMAIL_SERVICE_URL}/getAttachment`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ fileId })
//       });

//       if (response.ok) {
//         // For PDFs, ensure we get the correct content type
//         let blob = await response.blob();
//         if (contentType?.includes('pdf') && !blob.type.includes('pdf')) {
//           blob = new Blob([blob], { type: 'application/pdf' });
//         }
        
//         const url = window.URL.createObjectURL(blob);
        
//         // Check if it's a previewable file type
//         const previewableTypes = ['image/', 'application/pdf', 'text/', 'video/', 'audio/'];
//         const isPreviewable = previewableTypes.some(type => contentType?.includes(type));
        
//         if (isPreviewable) {
//           // Open in preview modal
//           setPreviewAttachment({
//             url,
//             fileName,
//             contentType,
//             blob
//           });
//         } else {
//           // Download the file
//           const link = document.createElement('a');
//           link.href = url;
//           link.download = fileName;
//           document.body.appendChild(link);
//           link.click();
//           document.body.removeChild(link);
//           window.URL.revokeObjectURL(url);
//         }
//       } else {
//         console.error('Failed to fetch attachment:', response.status);
//         alert('Failed to load attachment. Please try again.');
//       }
//     } catch (error) {
//       console.error('Error opening attachment:', error);
//       alert('Error loading attachment. Please try again.');
//     }
//   };

//   const closePreview = () => {
//     if (previewAttachment?.url) {
//       window.URL.revokeObjectURL(previewAttachment.url);
//     }
//     setPreviewAttachment(null);
//   };

//   const downloadPreviewedFile = () => {
//     if (previewAttachment) {
//       const link = document.createElement('a');
//       link.href = previewAttachment.url;
//       link.download = previewAttachment.fileName;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     }
//   };

//   const getTimelineItemStyle = (index) => {
//     if (hoveredIndex === -1) return {};

//     const distance = Math.abs(index - hoveredIndex);
//     const baseSize = 40;
//     const hoveredSize = baseSize * 2.5;
//     const pushDistance = (hoveredSize - baseSize) / 2 + 8;

//     if (index === hoveredIndex) {
//       return { transform: 'scale(2.0) translateY(-25px)' };
//     } else if (distance === 1) {
//       const offset = index < hoveredIndex ? -pushDistance : pushDistance;
//       return { transform: `translateX(${offset}px)` };
//     } else if (distance === 2) {
//       const offset = index < hoveredIndex ? -pushDistance/3 : pushDistance/3;
//       return { transform: `translateX(${offset}px)` };
//     }
//     return {};
//   };

//   const formatTime = (timestamp) => {
//     if (!timestamp) return '';
//     return new Date(timestamp).toLocaleTimeString('en-US', {
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: false
//     });
//   };

//   const formatFileSize = (bytes) => {
//     if (!bytes) return '0 B';
//     if (bytes < 1024) return bytes + ' B';
//     if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
//     return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
//   };

//   const getFileIcon = (contentType) => {
//     if (!contentType) return '📄';
//     if (contentType.includes('pdf')) return '📕';
//     if (contentType.includes('image')) return '🖼️';
//     if (contentType.includes('video')) return '🎥';
//     if (contentType.includes('audio')) return '🎵';
//     if (contentType.includes('word') || contentType.includes('document')) return '📝';
//     if (contentType.includes('excel') || contentType.includes('spreadsheet')) return '📊';
//     if (contentType.includes('powerpoint') || contentType.includes('presentation')) return '📽️';
//     if (contentType.includes('zip') || contentType.includes('compressed')) return '🗜️';
//     return '📄';
//   };

//   const counts = getMessageCounts();
//   const filteredMessages = getFilteredMessages();

//   return (
//     <div style={styles.body}>
//       <style>{`
//         .filter-tab {
//           background: white;
//           border: none;
//           padding: 10px 18px;
//           border-radius: 8px;
//           cursor: pointer;
//           font-size: 14px;
//           font-weight: 500;
//           transition: all 0.3s;
//           display: flex;
//           align-items: center;
//           gap: 6px;
//           color: #667781;
//         }
//         .filter-tab:hover {
//           background: #e8e8e8;
//         }
//         .filter-tab.active {
//           background: #4a90e2;
//           color: white;
//         }
//         .filter-tab .count {
//           background: rgba(0, 0, 0, 0.1);
//           padding: 2px 8px;
//           border-radius: 12px;
//           font-size: 12px;
//           font-weight: 600;
//         }
//         .filter-tab.active .count {
//           background: rgba(255, 255, 255, 0.25);
//         }

//         .timeline-item {
//           position: relative;
//           width: 40px;
//           height: 40px;
//           flex-shrink: 0;
//           transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
//           cursor: pointer;
//         }
//         .timeline-icon {
//           width: 100%;
//           height: 100%;
//           background: rgba(255, 255, 255, 0.3);
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 18px;
//           backdrop-filter: blur(10px);
//           border: 2px solid rgba(255, 255, 255, 0.5);
//           box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
//         }
//         .timeline-item.sms .timeline-icon {
//           background: rgba(76, 175, 80, 0.3);
//         }
//         .timeline-item.email .timeline-icon {
//           background: rgba(33, 150, 243, 0.3);
//         }
//         .timeline-time {
//           position: absolute;
//           bottom: -20px;
//           left: 50%;
//           transform: translateX(-50%);
//           font-size: 10px;
//           color: rgba(255, 255, 255, 0.8);
//           white-space: nowrap;
//           opacity: 0;
//           transition: opacity 0.3s;
//         }
//         .timeline-item:hover .timeline-time {
//           opacity: 1;
//         }
//         .timeline-preview {
//           position: absolute;
//           bottom: 60px;
//           left: 50%;
//           transform: translateX(-50%) scale(0.8);
//           background: white;
//           border-radius: 12px;
//           padding: 15px;
//           box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
//           width: 280px;
//           opacity: 0;
//           pointer-events: none;
//           transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
//           z-index: 1000;
//         }
//         .timeline-item:hover .timeline-preview {
//           opacity: 1;
//           transform: translateX(-50%) scale(1);
//         }
//         .timeline-preview-time {
//           display: block;
//           font-size: 11px;
//           color: #999;
//           margin-bottom: 5px;
//         }
//         .timeline-preview-subject {
//           display: block;
//           font-weight: 600;
//           color: #333;
//           margin-bottom: 5px;
//           font-size: 13px;
//         }
//         .timeline-preview-text {
//           display: block;
//           font-size: 12px;
//           color: #666;
//           line-height: 1.4;
//         }

//         .message {
//           display: flex;
//           margin-bottom: 16px;
//           animation: fadeIn 0.3s;
//         }
//         @keyframes fadeIn {
//           from { opacity: 0; transform: translateY(10px); }
//           to { opacity: 1; transform: translateY(0); }
//         }
//         .message.sent {
//           justify-content: flex-end;
//         }
//         .message.received {
//           justify-content: flex-start;
//         }
//         .message-bubble {
//           max-width: 65%;
//           padding: 12px 16px;
//           border-radius: 12px;
//           position: relative;
//           box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
//         }
//         .message.sent .message-bubble {
//           background: #dcf8c6;
//           border-bottom-right-radius: 4px;
//         }
//         .message.received .message-bubble {
//           background: white;
//           border-bottom-left-radius: 4px;
//         }
//         .message-name {
//           font-size: 12px;
//           font-weight: 600;
//           color: #4a90e2;
//           margin-bottom: 4px;
//         }
//         .message-type {
//           display: inline-block;
//           font-size: 11px;
//           background: rgba(0, 0, 0, 0.06);
//           padding: 3px 8px;
//           border-radius: 10px;
//           margin-bottom: 6px;
//           color: #666;
//         }
//         .email-subject {
//           font-weight: 600;
//           color: #333;
//           margin-bottom: 6px;
//           font-size: 14px;
//         }
//         .message-text {
//           color: #303030;
//           line-height: 1.5;
//           font-size: 14px;
//           word-wrap: break-word;
//         }
//         .message-footer {
//           display: flex;
//           justify-content: flex-end;
//           align-items: center;
//           gap: 5px;
//           margin-top: 6px;
//         }
//         .timestamp {
//           font-size: 11px;
//           color: #667781;
//         }
//         .checkmark {
//           font-size: 14px;
//           color: #34b7f1;
//         }
//         .checkmark.read {
//           color: #4fc3f7;
//         }

//         .attachments-list {
//           margin-top: 10px;
//           display: flex;
//           flex-direction: column;
//           gap: 8px;
//         }
//         .attachment-item {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           padding: 10px;
//           background: rgba(0, 0, 0, 0.04);
//           border-radius: 8px;
//           cursor: pointer;
//           transition: all 0.2s;
//           text-decoration: none;
//           color: inherit;
//         }
//         .attachment-item:hover {
//           background: rgba(0, 0, 0, 0.08);
//           transform: translateX(4px);
//         }
//         .attachment-icon {
//           font-size: 20px;
//         }
//         .attachment-name {
//           flex: 1;
//           font-size: 13px;
//           color: #333;
//           font-weight: 500;
//           overflow: hidden;
//           text-overflow: ellipsis;
//           white-space: nowrap;
//         }
//         .attachment-size {
//           font-size: 11px;
//           color: #999;
//         }

//         .email-container-wrapper {
//           position: absolute;
//           bottom: 100%;
//           left: 0;
//           right: 0;
//           background: white;
//           border-top: 1px solid #ddd;
//           box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.1);
//           max-height: 0;
//           overflow: hidden;
//           transition: max-height 0.3s;
//         }
//         .email-container-wrapper.active {
//           max-height: 600px;
//           overflow-y: auto;
//         }

//         button:hover {
//           opacity: 0.9;
//         }
//         input:focus, textarea:focus, select:focus {
//           border-color: #4a90e2;
//         }
//         .refresh-btn:hover {
//           background: rgba(255, 255, 255, 0.3) !important;
//           transform: rotate(180deg);
//         }
//         .close-email-btn:hover,
//         .preview-close-btn:hover {
//           background: rgba(0, 0, 0, 0.05) !important;
//         }
//         .send-btn:hover {
//           background: #357abd !important;
//         }
//         .email-send-btn:hover {
//           background: #357abd !important;
//         }
//         .preview-download-btn:hover {
//           background: #357abd !important;
//         }
//         .attach-btn:hover {
//           background: #f5f5f5 !important;
//           border-color: #4a90e2 !important;
//         }
//       `}</style>

//       {/* Compact Header with Timeline */}
//       <div style={styles.header}>
//         <div style={styles.headerContent}>
//           <div style={styles.timelineContainer}>
//             <div style={styles.timelineBar} ref={timelineBarRef}>
//               {filteredMessages.map((msg, index) => {
//                 const icon = msg.type === 'sms' ? '💬' : '📧';
//                 const time = formatTime(msg.timestamp);
//                 const messageBody = msg.text || '[No content]';
//                 const preview = messageBody.length > 150 
//                   ? messageBody.substring(0, 150) + '...' 
//                   : messageBody;

//                 return (
//                   <div
//                     key={index}
//                     className={`timeline-item ${msg.type}`}
//                     style={getTimelineItemStyle(index)}
//                   >
//                     <div className="timeline-icon">{icon}</div>
//                     <div className="timeline-time">{time}</div>
//                     <div className="timeline-preview">
//                       <span className="timeline-preview-time">{time}</span>
//                       {msg.subject && (
//                         <span className="timeline-preview-subject">
//                           Subject: {msg.subject}
//                         </span>
//                       )}
//                       <span className="timeline-preview-text">{preview}</span>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//           <button style={styles.refreshBtn} onClick={loadMessages} className="refresh-btn">
//             🔄
//           </button>
//         </div>
//       </div>

//       {/* Filter Tabs */}
//       <div style={styles.filterTabs}>
//         <button
//           className={`filter-tab ${currentFilter === 'all' ? 'active' : ''}`}
//           onClick={() => filterMessages('all')}
//         >
//           All <span className="count">{counts.all}</span>
//         </button>
//         <button
//           className={`filter-tab ${currentFilter === 'sms' ? 'active' : ''}`}
//           onClick={() => filterMessages('sms')}
//         >
//           💬 SMS <span className="count">{counts.sms}</span>
//         </button>
//         <button
//           className={`filter-tab ${currentFilter === 'email' ? 'active' : ''}`}
//           onClick={() => filterMessages('email')}
//         >
//           📧 Email <span className="count">{counts.email}</span>
//         </button>
//       </div>

//       {/* Messages */}
//       <div style={styles.content}>
//         <div style={styles.messagesContainer} ref={messagesContainerRef}>
//           {filteredMessages.length === 0 ? (
//             <div style={styles.loading}>
//               No {currentFilter !== 'all' ? currentFilter.toUpperCase() : ''} messages yet. Start a conversation!
//             </div>
//           ) : (
//             filteredMessages.map((msg, index) => {
//               const isOutbound = msg.direction === 'outbound';
//               const time = formatTime(msg.timestamp);

//               return (
//                 <div key={index} className={`message ${isOutbound ? 'sent' : 'received'}`}>
//                   <div className="message-bubble">
//                     {!isOutbound && msg.from && (
//                       <div className="message-name">{msg.from}</div>
//                     )}
//                     <div className="message-type">
//                       {msg.type === 'sms' ? '💬 SMS' : '📧 Email'}
//                     </div>
//                     {msg.subject && (
//                       <div className="email-subject">Subject: {msg.subject}</div>
//                     )}
//                     <div className="message-text">{msg.text || '[HTML Content]'}</div>
                    
//                     {msg.attachments && msg.attachments.length > 0 && (
//                       <div className="attachments-list">
//                         {msg.attachments.map((att, i) => (
//                           <a
//                             key={i}
//                             className="attachment-item"
//                             onClick={(e) => {
//                               e.preventDefault();
//                               openAttachment(att.fileId, att.originalFileName || att.fileName, att.contentType);
//                             }}
//                             href="#"
//                           >
//                             <span className="attachment-icon">
//                               {getFileIcon(att.contentType)}
//                             </span>
//                             <span className="attachment-name">
//                               {att.originalFileName || att.fileName}
//                             </span>
//                             <span className="attachment-size">
//                               {formatFileSize(att.fileSize)}
//                             </span>
//                           </a>
//                         ))}
//                       </div>
//                     )}
                    
//                     <div className="message-footer">
//                       <span className="timestamp">{time}</span>
//                       {isOutbound && <span className="checkmark read">✓✓</span>}
//                     </div>
//                   </div>
//                 </div>
//               );
//             })
//           )}
//         </div>

//         {/* Input Area */}
//         <div style={styles.inputArea}>
//           {/* Email Form */}
//           {inputMode === 'email' && (
//             <div className="email-container-wrapper active">
//               <div style={styles.emailContainerHeader}>
//                 <div style={styles.emailContainerTitle}>📧 Compose Email</div>
//                 <button
//                   style={styles.closeEmailBtn}
//                   onClick={() => setInputMode('sms')}
//                   className="close-email-btn"
//                 >
//                   ×
//                 </button>
//               </div>
//               <div style={styles.emailFormContent}>
//                 <form onSubmit={sendEmail}>
//                   <div style={styles.formGroup}>
//                     <label style={styles.formLabel}>From</label>
//                     <input
//                       style={styles.formInput}
//                       value={emailFormData.from}
//                       onChange={(e) => setEmailFormData({...emailFormData, from: e.target.value})}
//                       required
//                     />
//                   </div>
//                   <div style={styles.formGroup}>
//                     <label style={styles.formLabel}>To</label>
//                     <input
//                       type="email"
//                       style={styles.formInput}
//                       value={emailFormData.to}
//                       onChange={(e) => setEmailFormData({...emailFormData, to: e.target.value})}
//                       placeholder="recipient@example.com"
//                       required
//                     />
//                   </div>
//                   <div style={{...styles.formRow}}>
//                     <div style={styles.formGroup}>
//                       <label style={styles.formLabel}>CC</label>
//                       <input
//                         type="email"
//                         style={styles.formInput}
//                         value={emailFormData.cc}
//                         onChange={(e) => setEmailFormData({...emailFormData, cc: e.target.value})}
//                         placeholder="cc@example.com"
//                       />
//                     </div>
//                     <div style={styles.formGroup}>
//                       <label style={styles.formLabel}>BCC</label>
//                       <input
//                         type="email"
//                         style={styles.formInput}
//                         value={emailFormData.bcc}
//                         onChange={(e) => setEmailFormData({...emailFormData, bcc: e.target.value})}
//                         placeholder="bcc@example.com"
//                       />
//                     </div>
//                   </div>
//                   <div style={styles.formGroup}>
//                     <label style={styles.formLabel}>Subject</label>
//                     <input
//                       style={styles.formInput}
//                       value={emailFormData.subject}
//                       onChange={(e) => setEmailFormData({...emailFormData, subject: e.target.value})}
//                       placeholder="Enter subject"
//                       required
//                     />
//                   </div>
//                   <div style={styles.formGroup}>
//                     <label style={styles.formLabel}>Message</label>
//                     <textarea
//                       style={{...styles.formInput, ...styles.formTextarea}}
//                       value={emailFormData.body}
//                       onChange={(e) => setEmailFormData({...emailFormData, body: e.target.value})}
//                       placeholder="Write your email..."
//                       required
//                     />
//                   </div>
//                   <div style={styles.formGroup}>
//                     <label style={styles.formLabel}>Attachments</label>
//                     <div style={styles.attachmentArea}>
//                       <label style={styles.attachBtn} className="attach-btn">
//                         <span>📎</span>
//                         <span>Attach Files</span>
//                         <input
//                           type="file"
//                           multiple
//                           style={{display: 'none'}}
//                           onChange={handleFileChange}
//                         />
//                       </label>
//                       <div style={styles.attachmentList}>
//                         {attachments.length > 0
//                           ? `${attachments.length} file(s): ${attachments.map(f => f.name).join(', ')}`
//                           : 'No files selected'}
//                       </div>
//                     </div>
//                   </div>
//                   <button type="submit" style={styles.emailSendBtn} className="email-send-btn">
//                     Send Email
//                   </button>
//                 </form>
//               </div>
//             </div>
//           )}

//           {/* Input Controls */}
//           <div style={styles.inputControls}>
//             <select
//               style={styles.modeSelectorDropdown}
//               value={inputMode}
//               onChange={(e) => setInputMode(e.target.value)}
//             >
//               <option value="sms">💬 SMS</option>
//               <option value="email">📧 Email</option>
//             </select>

//             {inputMode === 'sms' && (
//               <div style={styles.smsInputContainer}>
//                 <select
//                   style={styles.numberSelector}
//                   value={fromNumber}
//                   onChange={(e) => setFromNumber(e.target.value)}
//                 >
//                   <option value="+16478463028">+1 (647) 846-3028</option>
//                   <option value="+18882131090">+1 (888) 213-1090</option>
//                   <option value="+14165555678">+1 (416) 555-5678</option>
//                 </select>
//                 <input
//                   type="text"
//                   style={styles.chatInput}
//                   value={smsText}
//                   onChange={(e) => setSmsText(e.target.value)}
//                   onKeyPress={(e) => e.key === 'Enter' && sendChatMessage()}
//                   placeholder="Type a message..."
//                 />
//                 <button style={styles.sendBtn} onClick={sendChatMessage} className="send-btn">
//                   Send
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Attachment Preview Modal */}
//       {previewAttachment && (
//         <div style={styles.previewModal} onClick={closePreview}>
//           <div style={styles.previewContent} onClick={(e) => e.stopPropagation()}>
//             <div style={styles.previewHeader}>
//               <div style={styles.previewTitle}>{previewAttachment.fileName}</div>
//               <div style={styles.previewActions}>
//                 <button style={styles.previewDownloadBtn} onClick={downloadPreviewedFile} className="preview-download-btn">
//                   ⬇️ Download
//                 </button>
//                 <button style={styles.previewCloseBtn} onClick={closePreview} className="preview-close-btn">
//                   ✕
//                 </button>
//               </div>
//             </div>
//             <div style={styles.previewBody}>
//               {previewAttachment.contentType?.includes('image/') && (
//                 <img 
//                   src={previewAttachment.url} 
//                   alt={previewAttachment.fileName}
//                   style={styles.previewImage}
//                 />
//               )}
//               {previewAttachment.contentType?.includes('application/pdf') && (
//                 <iframe 
//                   src={previewAttachment.url} 
//                   style={styles.previewIframe}
//                   title={previewAttachment.fileName}
//                 />
//               )}
//               {previewAttachment.contentType?.includes('video/') && (
//                 <video 
//                   src={previewAttachment.url} 
//                   controls
//                   style={styles.previewVideo}
//                 />
//               )}
//               {previewAttachment.contentType?.includes('audio/') && (
//                 <audio 
//                   src={previewAttachment.url} 
//                   controls
//                   style={styles.previewAudio}
//                 />
//               )}
//               {previewAttachment.contentType?.includes('text/') && (
//                 <iframe 
//                   src={previewAttachment.url} 
//                   style={styles.previewIframe}
//                   title={previewAttachment.fileName}
//                 />
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// const styles = {
//   body: {
//     fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
//     background: '#f5f5f5',
//     height: '100vh',
//     display: 'flex',
//     flexDirection: 'column',
//     overflow: 'hidden',
//     margin: 0,
//     padding: 0
//   },
//   header: {
//     background: 'linear-gradient(135deg, #4a7fd5 0%, #3d6bc6 100%)',
//     padding: '15px 20px',
//     color: 'white',
//     flexShrink: 0
//   },
//   headerContent: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '15px'
//   },
//   timelineContainer: {
//     flex: 1,
//     position: 'relative',
//     height: '80px',
//     display: 'flex',
//     alignItems: 'center',
//     overflow: 'visible'
//   },
//   timelineBar: {
//     display: 'flex',
//     alignItems: 'flex-end',
//     gap: '8px',
//     padding: '10px 15px',
//     position: 'relative',
//     justifyContent: 'center',
//     flexWrap: 'nowrap',
//     background: 'rgba(255, 255, 255, 0.15)',
//     backdropFilter: 'blur(10px)',
//     borderRadius: '15px',
//     boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
//     overflow: 'visible',
//     width: '100%'
//   },
//   refreshBtn: {
//     background: 'rgba(255, 255, 255, 0.2)',
//     color: 'white',
//     border: 'none',
//     padding: '10px',
//     borderRadius: '50%',
//     cursor: 'pointer',
//     fontSize: '16px',
//     fontWeight: 500,
//     transition: 'all 0.3s',
//     backdropFilter: 'blur(10px)',
//     width: '40px',
//     height: '40px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     flexShrink: 0
//   },
//   filterTabs: {
//     display: 'flex',
//     background: '#f8f9fa',
//     padding: '10px 20px',
//     gap: '10px',
//     borderBottom: '2px solid #e0e0e0',
//     flexShrink: 0
//   },
//   content: {
//     flex: 1,
//     display: 'flex',
//     flexDirection: 'column',
//     overflow: 'hidden',
//     minHeight: 0
//   },
//   messagesContainer: {
//     flex: 1,
//     overflowY: 'auto',
//     overflowX: 'hidden',
//     padding: '20px',
//     background: '#e5ddd5',
//     minHeight: 0
//   },
//   loading: {
//     textAlign: 'center',
//     padding: '20px',
//     color: '#667781'
//   },
//   inputArea: {
//     background: '#f0f0f0',
//     borderTop: '1px solid #ddd',
//     flexShrink: 0,
//     position: 'relative'
//   },
//   inputControls: {
//     display: 'flex',
//     padding: '15px 20px',
//     gap: '10px',
//     alignItems: 'stretch'
//   },
//   modeSelectorDropdown: {
//     background: 'white',
//     border: '1px solid #ddd',
//     borderRadius: '25px',
//     padding: '0 12px',
//     fontSize: '14px',
//     cursor: 'pointer',
//     outline: 'none',
//     minWidth: '120px',
//     fontWeight: 500,
//     color: '#4a90e2'
//   },
//   smsInputContainer: {
//     display: 'flex',
//     gap: '10px',
//     flex: 1,
//     alignItems: 'stretch'
//   },
//   numberSelector: {
//     background: 'white',
//     border: '1px solid #ddd',
//     borderRadius: '25px',
//     padding: '0 12px',
//     fontSize: '14px',
//     outline: 'none',
//     minWidth: '150px'
//   },
//   chatInput: {
//     flex: 1,
//     padding: '12px 15px',
//     border: '1px solid #ddd',
//     borderRadius: '25px',
//     fontSize: '14px',
//     outline: 'none',
//     background: 'white'
//   },
//   sendBtn: {
//     background: '#4a90e2',
//     color: 'white',
//     border: 'none',
//     padding: '12px 25px',
//     borderRadius: '25px',
//     cursor: 'pointer',
//     fontSize: '14px',
//     fontWeight: 500,
//     transition: 'background 0.3s',
//     flexShrink: 0
//   },
//   emailContainerHeader: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: '15px 20px',
//     borderBottom: '1px solid #e0e0e0',
//     background: '#f8f9fa'
//   },
//   emailContainerTitle: {
//     fontSize: '16px',
//     fontWeight: 600,
//     color: '#333'
//   },
//   closeEmailBtn: {
//     background: 'none',
//     border: 'none',
//     fontSize: '24px',
//     cursor: 'pointer',
//     color: '#666',
//     padding: 0,
//     width: '30px',
//     height: '30px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     borderRadius: '50%',
//     transition: 'all 0.3s'
//   },
//   emailFormContent: {
//     padding: '20px'
//   },
//   formGroup: {
//     marginBottom: '15px'
//   },
//   formLabel: {
//     display: 'block',
//     fontWeight: 600,
//     color: '#333',
//     marginBottom: '6px',
//     fontSize: '13px'
//   },
//   formInput: {
//     width: '100%',
//     padding: '10px 12px',
//     border: '1px solid #ddd',
//     borderRadius: '6px',
//     fontSize: '14px',
//     outline: 'none',
//     transition: 'border-color 0.3s',
//     boxSizing: 'border-box'
//   },
//   formTextarea: {
//     minHeight: '120px',
//     resize: 'vertical',
//     fontFamily: 'inherit'
//   },
//   formRow: {
//     display: 'grid',
//     gridTemplateColumns: '1fr 1fr',
//     gap: '15px'
//   },
//   attachmentArea: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '10px'
//   },
//   attachBtn: {
//     padding: '8px 16px',
//     border: '1px solid #ddd',
//     background: 'white',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     fontSize: '13px',
//     transition: 'all 0.3s',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '6px'
//   },
//   attachmentList: {
//     flex: 1,
//     fontSize: '12px',
//     color: '#666'
//   },
//   emailSendBtn: {
//     background: '#4a90e2',
//     color: 'white',
//     border: 'none',
//     padding: '12px 35px',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     fontSize: '14px',
//     fontWeight: 600,
//     transition: 'background 0.3s',
//     marginTop: '5px'
//   },
//   previewModal: {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: 'rgba(0, 0, 0, 0.85)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     zIndex: 10000,
//     padding: '20px'
//   },
//   previewContent: {
//     background: 'white',
//     borderRadius: '12px',
//     maxWidth: '90vw',
//     maxHeight: '90vh',
//     width: '900px',
//     display: 'flex',
//     flexDirection: 'column',
//     overflow: 'hidden',
//     boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
//   },
//   previewHeader: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: '15px 20px',
//     borderBottom: '1px solid #e0e0e0',
//     background: '#f8f9fa'
//   },
//   previewTitle: {
//     fontSize: '16px',
//     fontWeight: 600,
//     color: '#333',
//     overflow: 'hidden',
//     textOverflow: 'ellipsis',
//     whiteSpace: 'nowrap',
//     flex: 1,
//     marginRight: '20px'
//   },
//   previewActions: {
//     display: 'flex',
//     gap: '10px',
//     alignItems: 'center'
//   },
//   previewDownloadBtn: {
//     background: '#4a90e2',
//     color: 'white',
//     border: 'none',
//     padding: '8px 16px',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     fontSize: '13px',
//     fontWeight: 500,
//     transition: 'all 0.3s'
//   },
//   previewCloseBtn: {
//     background: 'none',
//     border: 'none',
//     fontSize: '24px',
//     cursor: 'pointer',
//     color: '#666',
//     padding: 0,
//     width: '32px',
//     height: '32px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     borderRadius: '50%',
//     transition: 'all 0.3s'
//   },
//   previewBody: {
//     flex: 1,
//     overflow: 'auto',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     padding: '20px',
//     background: '#f5f5f5'
//   },
//   previewImage: {
//     maxWidth: '100%',
//     maxHeight: '100%',
//     objectFit: 'contain',
//     borderRadius: '8px'
//   },
//   previewIframe: {
//     width: '100%',
//     height: '100%',
//     border: 'none',
//     borderRadius: '8px',
//     background: 'white'
//   },
//   previewVideo: {
//     maxWidth: '100%',
//     maxHeight: '100%',
//     borderRadius: '8px'
//   },
//   previewAudio: {
//     width: '100%',
//     maxWidth: '500px'
//   }
// };

// export default SmsEmail;

import React, { useState, useEffect, useRef } from 'react';

const SmsEmail = ({LeadACVLRecordID, Email, PhoneNumber, accessToken, Salesagent, initialMode = 'sms'}) => {
  const API_BASE_URL = 'https://salesjet-841904208.development.catalystserverless.com/server/SMSRecords';
  const EMAIL_SERVICE_URL = 'https://salesjet-841904208.development.catalystserverless.com/server/salesjet_function';
  const LEAD_ID = LeadACVLRecordID || 'LEAD_22222';
  const TO_NUMBER = PhoneNumber || '+14166134241';
  const SALES_AGENT = Salesagent || '';
  const TO_EMAIL = Email ;
  const [allMessages, setAllMessages] = useState([]);
  const [inputMode, setInputMode] = useState(initialMode);
  const [currentFilter, setCurrentFilter] = useState('all');
  const [smsText, setSmsText] = useState('');
  const [fromNumber, setFromNumber] = useState('');
  const [availableNumbers, setAvailableNumbers] = useState([]);
  const [emailFormData, setEmailFormData] = useState({
    to: TO_EMAIL ||'',
    subject: '',
    body: ''
  });
  const [attachments, setAttachments] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(-1);
  const [previewAttachment, setPreviewAttachment] = useState(null);

  const messagesContainerRef = useRef(null);
  const timelineBarRef = useRef(null);

  const loadAvailableNumbers = async () => {
    if (!LEAD_ID) {
      console.log('No lead_id provided, using default numbers');
      setAvailableNumbers(['+16478463028', '+18882131090']);
      setFromNumber('+16478463028');
      return;
    }

    try {
      const url = `${API_BASE_URL}/get_latest_agent_number_list?lead_id=${encodeURIComponent(LEAD_ID)}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (response.ok) {
        const data = await response.json();
        
        if (data && Array.isArray(data.number_list) && data.number_list.length > 0) {
          setAvailableNumbers(data.number_list);
          // Set the first number (most recently used) as default
          setFromNumber(data.number_list[0]);
        } else {
          // Fallback to default numbers
          setAvailableNumbers(['+16478463028', '+18882131090']);
          setFromNumber('+16478463028');
        }
      } else {
        // Fallback on error
        setAvailableNumbers(['+16478463028', '+18882131090']);
        setFromNumber('+16478463028');
      }
    } catch (error) {
      console.error('Error loading numbers:', error);
      // Fallback to default numbers if API fails
      setAvailableNumbers(['+16478463028', '+18882131090']);
      setFromNumber('+16478463028');
    }
  };

  useEffect(() => {
    setInputMode(initialMode);
  }, [initialMode]);

  useEffect(() => {
    loadMessages();
    loadAvailableNumbers();
  }, [LEAD_ID]);

  useEffect(() => {
    const timelineBar = timelineBarRef.current;
    if (!timelineBar) return;

    const handleMouseMove = (e) => {
      const items = Array.from(timelineBar.querySelectorAll('.timeline-item'));
      let currentHoveredIndex = -1;

      items.forEach((item, idx) => {
        const rect = item.getBoundingClientRect();
        const itemCenter = rect.left + rect.width / 2;
        const distance = Math.abs(e.clientX - itemCenter);
        if (distance < 40) {
          currentHoveredIndex = idx;
        }
      });

      setHoveredIndex(currentHoveredIndex);
    };

    const handleMouseLeave = () => {
      setHoveredIndex(-1);
    };

    timelineBar.addEventListener('mousemove', handleMouseMove);
    timelineBar.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      timelineBar.removeEventListener('mousemove', handleMouseMove);
      timelineBar.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [allMessages]);

  // Auto-scroll messages
  useEffect(() => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
    }
  }, [allMessages, currentFilter]);

  const loadMessages = async () => {
    try {
      const url = `${API_BASE_URL}/get_unified_history?lead_id=${encodeURIComponent(LEAD_ID)}`;
      const response = await fetch(url);
      if (response.ok) {
        const data = await response.json();
        setAllMessages(data.messages || []);
      }
    } catch (error) {
      console.error('Error loading messages:', error);
    }
  };

  const filterMessages = (type) => {
    setCurrentFilter(type);
  };

  const getFilteredMessages = () => {
    if (currentFilter === 'all') return allMessages;
    return allMessages.filter(m => m.type === currentFilter);
  };

  const getMessageCounts = () => {
    return {
      all: allMessages.length,
      sms: allMessages.filter(m => m.type === 'sms').length,
      email: allMessages.filter(m => m.type === 'email').length
    };
  };

  const sendChatMessage = async () => {
    if (!smsText.trim()) return;

    const now = new Date();
    const time = now.getHours().toString().padStart(2, '0') + ':' + 
                 now.getMinutes().toString().padStart(2, '0');

    // Optimistic update
    const tempMessage = {
      type: 'sms',
      direction: 'outbound',
      from: fromNumber,
      to: TO_NUMBER,
      text: smsText,
      timestamp: new Date().toISOString(),
      lead_id: LEAD_ID
    };
    setAllMessages([...allMessages, tempMessage]);
    setSmsText('');

    try {
      // const url = `${API_BASE_URL}/sendSMS?from=${encodeURIComponent(fromNumber)}&to=${encodeURIComponent(TO_NUMBER)}&text=${encodeURIComponent(smsText)}&lead_id=${encodeURIComponent(LEAD_ID)}`;
      const url = `${API_BASE_URL}/sendSMS?from=${encodeURIComponent(fromNumber)}&to=${encodeURIComponent(TO_NUMBER)}&text=${encodeURIComponent(smsText)}&lead_id=${encodeURIComponent(LEAD_ID)}&sales_agent=${encodeURIComponent(SALES_AGENT)}`;
      const response = await fetch(url, { method: 'GET' });
      
      if (response.ok) {
        setTimeout(() => loadMessages(), 1000);
      }
    } catch (error) {
      console.error('Error sending SMS:', error);
    }
  };

  const sendEmail = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('to', emailFormData.to);
    formData.append('subject', emailFormData.subject);
    formData.append('text', emailFormData.body);
    formData.append('leadId', LEAD_ID);

    if (emailFormData.cc) formData.append('cc', emailFormData.cc);
    if (emailFormData.bcc) formData.append('bcc', emailFormData.bcc);

    attachments.forEach(file => {
      formData.append('attachment', file);
    });

    // Optimistic update
    const tempMessage = {
      type: 'email',
      direction: 'outbound',
      to: emailFormData.to,
      subject: emailFormData.subject,
      text: emailFormData.body,
      timestamp: new Date().toISOString(),
      lead_id: LEAD_ID
    };
    setAllMessages([...allMessages, tempMessage]);

    try {
      const response = await fetch(`${API_BASE_URL}/sendEmail`, {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        setEmailFormData({
          to: TO_EMAIL || '',
          subject: '',
          body: ''
        });
        setAttachments([]);
        setInputMode('sms');
        setTimeout(() => loadMessages(), 1000);
      }
    } catch (error) {
      console.error('Error sending email:', error);
    }
  };

  const handleFileChange = (e) => {
    setAttachments(Array.from(e.target.files));
  };

  const openAttachment = async (fileId, fileName, contentType) => {
    try {
      const response = await fetch(`${EMAIL_SERVICE_URL}/getAttachment`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fileId })
      });

      if (response.ok) {
        // For PDFs, ensure we get the correct content type
        let blob = await response.blob();
        if (contentType?.includes('pdf') && !blob.type.includes('pdf')) {
          blob = new Blob([blob], { type: 'application/pdf' });
        }
        
        const url = window.URL.createObjectURL(blob);
        
        // Check if it's a previewable file type
        const previewableTypes = ['image/', 'application/pdf', 'text/', 'video/', 'audio/'];
        const isPreviewable = previewableTypes.some(type => contentType?.includes(type));
        
        if (isPreviewable) {
          // Open in preview modal
          setPreviewAttachment({
            url,
            fileName,
            contentType,
            blob
          });
        } else {
          // Download the file
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }
      } else {
        console.error('Failed to fetch attachment:', response.status);
        alert('Failed to load attachment. Please try again.');
      }
    } catch (error) {
      console.error('Error opening attachment:', error);
      alert('Error loading attachment. Please try again.');
    }
  };

  const closePreview = () => {
    if (previewAttachment?.url) {
      window.URL.revokeObjectURL(previewAttachment.url);
    }
    setPreviewAttachment(null);
  };

  const downloadPreviewedFile = () => {
    if (previewAttachment) {
      const link = document.createElement('a');
      link.href = previewAttachment.url;
      link.download = previewAttachment.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const getTimelineItemStyle = (index) => {
    if (hoveredIndex === -1) return {};

    const distance = Math.abs(index - hoveredIndex);
    const baseSize = 40;
    const hoveredSize = baseSize * 2.5;
    const pushDistance = (hoveredSize - baseSize) / 2 + 8;

    if (index === hoveredIndex) {
      return { transform: 'scale(2.0) translateY(-25px)' };
    } else if (distance === 1) {
      const offset = index < hoveredIndex ? -pushDistance : pushDistance;
      return { transform: `translateX(${offset}px)` };
    } else if (distance === 2) {
      const offset = index < hoveredIndex ? -pushDistance/3 : pushDistance/3;
      return { transform: `translateX(${offset}px)` };
    }
    return {};
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    return new Date(timestamp).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return '0 B';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  const getFileIcon = (contentType) => {
    if (!contentType) return '📄';
    if (contentType.includes('pdf')) return '📕';
    if (contentType.includes('image')) return '🖼️';
    if (contentType.includes('video')) return '🎥';
    if (contentType.includes('audio')) return '🎵';
    if (contentType.includes('word') || contentType.includes('document')) return '📝';
    if (contentType.includes('excel') || contentType.includes('spreadsheet')) return '📊';
    if (contentType.includes('powerpoint') || contentType.includes('presentation')) return '📽️';
    if (contentType.includes('zip') || contentType.includes('compressed')) return '🗜️';
    return '📄';
  };

  const counts = getMessageCounts();
  const filteredMessages = getFilteredMessages();

  return (
    <div style={styles.body}>
      <style>{`
        .filter-tab {
          background: white;
          border: none;
          padding: 10px 18px;
          border-radius: 8px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          transition: all 0.3s;
          display: flex;
          align-items: center;
          gap: 6px;
          color: #667781;
        }
        .filter-tab:hover {
          background: #e8e8e8;
        }
        .filter-tab.active {
          background: #4a90e2;
          color: white;
        }
        .filter-tab .count {
          background: rgba(0, 0, 0, 0.1);
          padding: 2px 8px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 600;
        }
        .filter-tab.active .count {
          background: rgba(255, 255, 255, 0.25);
        }

        .timeline-item {
          position: relative;
          width: 40px;
          height: 40px;
          flex-shrink: 0;
          transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
          cursor: pointer;
        }
        .timeline-icon {
          width: 100%;
          height: 100%;
          background: rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          backdrop-filter: blur(10px);
          border: 2px solid rgba(255, 255, 255, 0.5);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
        .timeline-item.sms .timeline-icon {
          background: rgba(76, 175, 80, 0.3);
        }
        .timeline-item.email .timeline-icon {
          background: rgba(33, 150, 243, 0.3);
        }
        .timeline-time {
          position: absolute;
          bottom: -20px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 10px;
          color: rgba(255, 255, 255, 0.8);
          white-space: nowrap;
          opacity: 0;
          transition: opacity 0.3s;
        }
        .timeline-item:hover .timeline-time {
          opacity: 1;
        }
        .timeline-preview {
          position: absolute;
          bottom: 60px;
          left: 50%;
          transform: translateX(-50%) scale(0.8);
          background: white;
          border-radius: 12px;
          padding: 15px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
          width: 280px;
          opacity: 0;
          pointer-events: none;
          transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
          z-index: 1000;
        }
        .timeline-item:hover .timeline-preview {
          opacity: 1;
          transform: translateX(-50%) scale(1);
        }
        .timeline-preview-time {
          display: block;
          font-size: 11px;
          color: #999;
          margin-bottom: 5px;
        }
        .timeline-preview-subject {
          display: block;
          font-weight: 600;
          color: #333;
          margin-bottom: 5px;
          font-size: 13px;
        }
        .timeline-preview-text {
          display: block;
          font-size: 12px;
          color: #666;
          line-height: 1.4;
        }

        .message {
          display: flex;
          margin-bottom: 16px;
          animation: fadeIn 0.3s;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .message.sent {
          justify-content: flex-end;
        }
        .message.received {
          justify-content: flex-start;
        }
        .message-bubble {
          max-width: 65%;
          padding: 12px 16px;
          border-radius: 12px;
          position: relative;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        }
        .message.sent .message-bubble {
          background: #dcf8c6;
          border-bottom-right-radius: 4px;
        }
        .message.received .message-bubble {
          background: white;
          border-bottom-left-radius: 4px;
        }
        .message-name {
          font-size: 12px;
          font-weight: 600;
          color: #4a90e2;
          margin-bottom: 4px;
        }
        .message-type {
          display: inline-block;
          font-size: 11px;
          background: rgba(0, 0, 0, 0.06);
          padding: 3px 8px;
          border-radius: 10px;
          margin-bottom: 6px;
          color: #666;
        }
        .email-subject {
          font-weight: 600;
          color: #333;
          margin-bottom: 6px;
          font-size: 14px;
        }
        .message-text {
          color: #303030;
          line-height: 1.5;
          font-size: 14px;
          word-wrap: break-word;
        }
        .message-footer {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          gap: 5px;
          margin-top: 6px;
        }
        .timestamp {
          font-size: 11px;
          color: #667781;
        }
        .checkmark {
          font-size: 14px;
          color: #34b7f1;
        }
        .checkmark.read {
          color: #4fc3f7;
        }

        .attachments-list {
          margin-top: 10px;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .attachment-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px;
          background: rgba(0, 0, 0, 0.04);
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.2s;
          text-decoration: none;
          color: inherit;
        }
        .attachment-item:hover {
          background: rgba(0, 0, 0, 0.08);
          transform: translateX(4px);
        }
        .attachment-icon {
          font-size: 20px;
        }
        .attachment-name {
          flex: 1;
          font-size: 13px;
          color: #333;
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .attachment-size {
          font-size: 11px;
          color: #999;
        }

        .email-container-wrapper {
          position: absolute;
          bottom: 100%;
          left: 0;
          right: 0;
          background: white;
          border-top: 1px solid #ddd;
          box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.1);
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s;
        }
        .email-container-wrapper.active {
          max-height: 600px;
          overflow-y: auto;
        }

        button:hover {
          opacity: 0.9;
        }
        input:focus, textarea:focus, select:focus {
          border-color: #4a90e2;
        }
        .refresh-btn:hover {
          background: rgba(255, 255, 255, 0.3) !important;
          transform: rotate(180deg);
        }
        .close-email-btn:hover,
        .preview-close-btn:hover {
          background: rgba(0, 0, 0, 0.05) !important;
        }
        .send-btn:hover {
          background: #357abd !important;
        }
        .email-send-btn:hover {
          background: #357abd !important;
        }
        .preview-download-btn:hover {
          background: #357abd !important;
        }
        .attach-btn:hover {
          background: #f5f5f5 !important;
          border-color: #4a90e2 !important;
        }
      `}</style>

      {/* Compact Header with Timeline */}
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <div style={styles.timelineContainer}>
            <div style={styles.timelineBar} ref={timelineBarRef}>
              {filteredMessages.map((msg, index) => {
                const icon = msg.type === 'sms' ? '💬' : '📧';
                const time = formatTime(msg.timestamp);
                const messageBody = msg.text || '[No content]';
                const preview = messageBody.length > 150 
                  ? messageBody.substring(0, 150) + '...' 
                  : messageBody;

                return (
                  <div
                    key={index}
                    className={`timeline-item ${msg.type}`}
                    style={getTimelineItemStyle(index)}
                  >
                    <div className="timeline-icon">{icon}</div>
                    <div className="timeline-time">{time}</div>
                    <div className="timeline-preview">
                      <span className="timeline-preview-time">{time}</span>
                      {msg.subject && (
                        <span className="timeline-preview-subject">
                          Subject: {msg.subject}
                        </span>
                      )}
                      <span className="timeline-preview-text">{preview}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <button style={styles.refreshBtn} onClick={loadMessages} className="refresh-btn">
            🔄
          </button>
        </div>
      </div>

      {/* Filter Tabs */}
      <div style={styles.filterTabs}>
        <button
          className={`filter-tab ${currentFilter === 'all' ? 'active' : ''}`}
          onClick={() => filterMessages('all')}
        >
          All <span className="count">{counts.all}</span>
        </button>
        <button
          className={`filter-tab ${currentFilter === 'sms' ? 'active' : ''}`}
          onClick={() => filterMessages('sms')}
        >
          💬 SMS <span className="count">{counts.sms}</span>
        </button>
        <button
          className={`filter-tab ${currentFilter === 'email' ? 'active' : ''}`}
          onClick={() => filterMessages('email')}
        >
          📧 Email <span className="count">{counts.email}</span>
        </button>
      </div>

      {/* Messages */}
      <div style={styles.content}>
        <div style={styles.messagesContainer} ref={messagesContainerRef}>
          {filteredMessages.length === 0 ? (
            <div style={styles.loading}>
              No {currentFilter !== 'all' ? currentFilter.toUpperCase() : ''} messages yet. Start a conversation!
            </div>
          ) : (
            filteredMessages.map((msg, index) => {
              const isOutbound = msg.direction === 'outbound';
              const time = formatTime(msg.timestamp);

              return (
                <div key={index} className={`message ${isOutbound ? 'sent' : 'received'}`}>
                  <div className="message-bubble">
                    {!isOutbound && msg.from && (
                      <div className="message-name">{msg.from}</div>
                    )}
                    <div className="message-type">
                      {msg.type === 'sms' ? '💬 SMS' : '📧 Email'}
                    </div>
                    {msg.subject && (
                      <div className="email-subject">Subject: {msg.subject}</div>
                    )}
                    <div className="message-text">{msg.text || '[HTML Content]'}</div>
                    
                    {msg.attachments && msg.attachments.length > 0 && (
                      <div className="attachments-list">
                        {msg.attachments.map((att, i) => (
                          <a
                            key={i}
                            className="attachment-item"
                            onClick={(e) => {
                              e.preventDefault();
                              openAttachment(att.fileId, att.originalFileName || att.fileName, att.contentType);
                            }}
                            href="#"
                          >
                            <span className="attachment-icon">
                              {getFileIcon(att.contentType)}
                            </span>
                            <span className="attachment-name">
                              {att.originalFileName || att.fileName}
                            </span>
                            <span className="attachment-size">
                              {formatFileSize(att.fileSize)}
                            </span>
                          </a>
                        ))}
                      </div>
                    )}
                    
                    <div className="message-footer">
                      <span className="timestamp">{time}</span>
                      {isOutbound && <span className="checkmark read">✓✓</span>}
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>

        {/* Input Area */}
        <div style={styles.inputArea}>
          {/* Email Form */}
          {inputMode === 'email' && (
            <div className="email-container-wrapper active">
              <div style={styles.emailContainerHeader}>
                <div style={styles.emailContainerTitle}>📧 Compose Email</div>
                <button
                  style={styles.closeEmailBtn}
                  onClick={() => setInputMode('sms')}
                  className="close-email-btn"
                >
                  ×
                </button>
              </div>
              <div style={styles.emailFormContent}>
                <form onSubmit={sendEmail}>
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Subject</label>
                    <input
                      style={styles.formInput}
                      value={emailFormData.subject}
                      onChange={(e) => setEmailFormData({...emailFormData, subject: e.target.value})}
                      placeholder="Enter subject"
                      required
                    />
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Message</label>
                    <textarea
                      style={{...styles.formInput, ...styles.formTextarea}}
                      value={emailFormData.body}
                      onChange={(e) => setEmailFormData({...emailFormData, body: e.target.value})}
                      placeholder="Write your email..."
                      required
                    />
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Attachments</label>
                    <div style={styles.attachmentArea}>
                      <label style={styles.attachBtn} className="attach-btn">
                        <span>📎</span>
                        <span>Attach Files</span>
                        <input
                          type="file"
                          multiple
                          style={{display: 'none'}}
                          onChange={handleFileChange}
                        />
                      </label>
                      <div style={styles.attachmentList}>
                        {attachments.length > 0
                          ? `${attachments.length} file(s): ${attachments.map(f => f.name).join(', ')}`
                          : 'No files selected'}
                      </div>
                    </div>
                  </div>
                  <button type="submit" style={styles.emailSendBtn} className="email-send-btn">
                    Send Email
                  </button>
                </form>
              </div>
            </div>
          )}

          {/* Input Controls */}
          <div style={styles.inputControls}>
            <select
              style={styles.modeSelectorDropdown}
              value={inputMode}
              onChange={(e) => setInputMode(e.target.value)}
            >
              <option value="sms">💬 SMS</option>
              <option value="email">📧 Email</option>
            </select>

            {inputMode === 'sms' && (
              <div style={styles.smsInputContainer}>
                <select
                  style={styles.numberSelector}
                  value={fromNumber}
                  onChange={(e) => setFromNumber(e.target.value)}
                >
                  {availableNumbers.length > 0 ? (
                    availableNumbers.map((number) => (
                      <option key={number} value={number}>
                        {number}
                      </option>
                    ))
                  ) : (
                    <>
                      <option value="+16478463028">+1 (647) 846-3028</option>
                      <option value="+18882131090">+1 (888) 213-1090</option>
                    </>
                  )}
                </select>
                <input
                  type="text"
                  style={styles.chatInput}
                  value={smsText}
                  onChange={(e) => setSmsText(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && sendChatMessage()}
                  placeholder="Type a message..."
                />
                <button style={styles.sendBtn} onClick={sendChatMessage} className="send-btn">
                  Send
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Attachment Preview Modal */}
      {previewAttachment && (
        <div style={styles.previewModal} onClick={closePreview}>
          <div style={styles.previewContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.previewHeader}>
              <div style={styles.previewTitle}>{previewAttachment.fileName}</div>
              <div style={styles.previewActions}>
                <button style={styles.previewDownloadBtn} onClick={downloadPreviewedFile} className="preview-download-btn">
                  ⬇️ Download
                </button>
                <button style={styles.previewCloseBtn} onClick={closePreview} className="preview-close-btn">
                  ✕
                </button>
              </div>
            </div>
            <div style={styles.previewBody}>
              {previewAttachment.contentType?.includes('image/') && (
                <img 
                  src={previewAttachment.url} 
                  alt={previewAttachment.fileName}
                  style={styles.previewImage}
                />
              )}
              {previewAttachment.contentType?.includes('application/pdf') && (
                <iframe 
                  src={previewAttachment.url} 
                  style={styles.previewIframe}
                  title={previewAttachment.fileName}
                />
              )}
              {previewAttachment.contentType?.includes('video/') && (
                <video 
                  src={previewAttachment.url} 
                  controls
                  style={styles.previewVideo}
                />
              )}
              {previewAttachment.contentType?.includes('audio/') && (
                <audio 
                  src={previewAttachment.url} 
                  controls
                  style={styles.previewAudio}
                />
              )}
              {previewAttachment.contentType?.includes('text/') && (
                <iframe 
                  src={previewAttachment.url} 
                  style={styles.previewIframe}
                  title={previewAttachment.fileName}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  body: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
    background: '#f5f5f5',
    height: '95vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    margin: 0,
    padding: 0
  },
  header: {
    background: '#4169e1',
    padding: '15px 20px',
    color: 'white',
    flexShrink: 0
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px'
  },
  timelineContainer: {
    flex: 1,
    position: 'relative',
    height: '80px',
    display: 'flex',
    alignItems: 'center',
    overflow: 'visible'
  },
  timelineBar: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '8px',
    padding: '10px 15px',
    position: 'relative',
    justifyContent: 'center',
    flexWrap: 'nowrap',
    background: 'rgba(255, 255, 255, 0.15)',
    backdropFilter: 'blur(10px)',
    borderRadius: '15px',
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
    overflow: 'visible',
    width: '100%'
  },
  refreshBtn: {
    background: 'rgba(255, 255, 255, 0.2)',
    color: 'white',
    border: 'none',
    padding: '10px',
    borderRadius: '50%',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 500,
    transition: 'all 0.3s',
    backdropFilter: 'blur(10px)',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  },
  filterTabs: {
    display: 'flex',
    background: '#f8f9fa',
    padding: '10px 20px',
    gap: '10px',
    borderBottom: '2px solid #e0e0e0',
    flexShrink: 0
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    minHeight: 0
  },
  messagesContainer: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '20px',
    background: '#e5ddd5',
    minHeight: 0
  },
  loading: {
    textAlign: 'center',
    padding: '20px',
    color: '#667781'
  },
  inputArea: {
    background: '#f0f0f0',
    borderTop: '1px solid #ddd',
    flexShrink: 0,
    position: 'relative'
  },
  inputControls: {
    display: 'flex',
    padding: '15px 20px',
    gap: '10px',
    alignItems: 'stretch'
  },
  modeSelectorDropdown: {
    background: 'white',
    border: '1px solid #ddd',
    borderRadius: '25px',
    padding: '12px',
    fontSize: '14px',
    cursor: 'pointer',
    outline: 'none',
    minWidth: '120px',
    fontWeight: 500,
    color: '#4a90e2'
  },
  smsInputContainer: {
    display: 'flex',
    gap: '10px',
    flex: 1,
    alignItems: 'stretch'
  },
  numberSelector: {
    background: 'white',
    border: '1px solid #ddd',
    borderRadius: '25px',
    padding: '0 12px',
    fontSize: '14px',
    outline: 'none',
    minWidth: '150px'
  },
  chatInput: {
    flex: 1,
    padding: '12px 15px',
    border: '1px solid #ddd',
    borderRadius: '25px',
    fontSize: '14px',
    outline: 'none',
    background: 'white'
  },
  sendBtn: {
    background: '#4a90e2',
    color: 'white',
    border: 'none',
    padding: '12px 25px',
    borderRadius: '25px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 500,
    transition: 'background 0.3s',
    flexShrink: 0
  },
  emailContainerHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '15px 20px',
    borderBottom: '1px solid #e0e0e0',
    background: '#f8f9fa'
  },
  emailContainerTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#333'
  },
  closeEmailBtn: {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: '#666',
    padding: 0,
    width: '30px',
    height: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    transition: 'all 0.3s'
  },
  emailFormContent: {
    padding: '20px'
  },
  formGroup: {
    // marginBottom: '15px'
  },
  formLabel: {
    display: 'block',
    fontWeight: 600,
    color: '#333',
    marginBottom: '6px',
    fontSize: '13px'
  },
  formInput: {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '14px',
    outline: 'none',
    transition: 'border-color 0.3s',
    boxSizing: 'border-box'
  },
  formTextarea: {
    minHeight: '120px',
    resize: 'vertical',
    fontFamily: 'inherit'
  },
  formRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '15px'
  },
  attachmentArea: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  attachBtn: {
    padding: '5px 5px',
    border: '1px solid #ddd',
    background: 'white',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '13px',
    transition: 'all 0.3s',
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  },
  attachmentList: {
    flex: 1,
    fontSize: '12px',
    color: '#666'
  },
  emailSendBtn: {
    background: '#4a90e2',
    color: 'white',
    border: 'none',
    padding: '5px 5px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 600,
    transition: 'background 0.3s',
    marginTop: '5px'
  },
  previewModal: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.85)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000,
    padding: '20px'
  },
  previewContent: {
    background: 'white',
    borderRadius: '12px',
    maxWidth: '90vw',
    maxHeight: '90vh',
    width: '900px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
  },
  previewHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '15px 20px',
    borderBottom: '1px solid #e0e0e0',
    background: '#f8f9fa'
  },
  previewTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#333',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
    marginRight: '20px'
  },
  previewActions: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center'
  },
  previewDownloadBtn: {
    background: '#4a90e2',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: 500,
    transition: 'all 0.3s'
  },
  previewCloseBtn: {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: '#666',
    padding: 0,
    width: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    transition: 'all 0.3s'
  },
  previewBody: {
    flex: 1,
    overflow: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    background: '#f5f5f5'
  },
  previewImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
    borderRadius: '8px'
  },
  previewIframe: {
    width: '100%',
    height: '100%',
    border: 'none',
    borderRadius: '8px',
    background: 'white'
  },
  previewVideo: {
    maxWidth: '100%',
    maxHeight: '100%',
    borderRadius: '8px'
  },
  previewAudio: {
    width: '100%',
    maxWidth: '500px'
  }
};

export default SmsEmail;